module.exports = __webpack_public_path__ + "static/media/arrow_left_icon.409a1c00.svg";